import {
  CHANNEL_KEYS,
  GROUP_KEYS,
} from "../../../utils/ManageBrandedCommunity.data";

/**
 * Extract and flatten an array of channels from an array of groups.
 *
 * @param {Array} groups - An array of objects representing groups.
 * @returns {Array} - An array containing all the channels extracted from the groups.
 */
export const getChannels = (groups) =>
  groups?.reduce(
    (channelsArray, { [GROUP_KEYS.channels]: channels }) =>
      channels ? [...channelsArray, ...channels] : channelsArray,
    []
  );

/**
 * Generates a mapping of channel UUIDs to their corresponding names from a given array of channels.
 *
 * @param {Array} channels - An array of channel objects.
 * @returns {Object} - A mapping object where keys are channel UUIDs and values are channel names.
 */
export const mapChannelsNameToUuids = (channels) =>
  channels?.reduce(
    (map, channel) => ({
      ...map,
      [channel[CHANNEL_KEYS.uuid]]: channel[CHANNEL_KEYS.name],
    }),
    {}
  ) || {};

export const mapMembershipNameToUuids = (memberships) =>
  memberships?.reduce(
    (map, membership) => ({
      ...map,
      [membership.uuid]: membership.title,
    }),
    {}
  ) || {};
